import {DismissalDecisionEN} from "./dismissal/en";
import {SalaryDecisionEN} from "./salary/en";
import {RewardDecisionEN} from "./reward/en";
import {AppointmentDecisionEN} from "./appointment/en";
import {AdmissionDecisionEN} from "./admission/en";
import {ReasonEN} from "./reason/en";
import {TransferDecisionEN} from "./transfer/en";
import {ContractDecisionEN} from "./contract/en";

export const DecisionEN = {
    "decision": {
        "titleHeader":"Decision",
        "employeeApproval" : "Employee Approval",
        "delete" : "Delete decision successfully",
        "placeholder": {
            "decisionNo": "QD001",
            "decisionMaker": "Enter decision maker",
            "employee": "Find employee",
            "reasonDecision": "Enter decision",
            "currentDepartment": "Current department",
            "currentJobPosition": "Current job job-job-position",
            "currentJobTitle": "Current job job-title",
            "currentContractType":" Current Contract",
            "newDepartment": "New Department",
            "newJobPosition": "New Job Position",
            "newJobTitle": "New Job Title",
            "newContractType":"New Contract",
            "description": "Description",
            "jobPosition": "Job Position",
            "jobTitle": "Job Title",
            "contractType": "Contract Type",
            "reason":"Reason",

        },
        "label": {
            "decisionNo": "Decision no",
            "decisionDate": "Decision date",
            "decisionMaker": "Decision maker",
            "validityDate": "Validity date",
            "employee": "Employee",
            "reasonDecision": "Decision reason",
            "currentDepartment": "Current department",
            "currentJobPosition": "Current job job-job-position",
            "currentJobTitle": "Current job job-title",
            "currentContractType":" Current Contract",
            "newDepartment": "New Department",
            "newJobPosition": "New Job Position",
            "newJobTitle": "New Job Title",
            "newContractType":"New Contract",
            "description": "Description",
            "status": "Status",
            "reason":"Reason",
            "type":"Type",
            "createDate":"Create date",
            "createName" : "Create Name",
            "department" : "Department",
            "jobPosition" : "Job Position" ,
            "jobTitle" : "Job Title",
            "reprimandMethod" : "Form",
            "amount" : "Salary",
            "amountBonus" : "Bonus"

        },
        "tabs": {
            "transfer": "Transfer decision",
            "reward": "Reward decision",
            "contract": "Contract decision",
            "discipline": "Discipline decision",
            "salary": "Salary decision",
            "admission": "Admission decision",
            "appointment": "Appointment decision",
            "dismissal": "Dismissal decision"
        },
    },
    ...DismissalDecisionEN,
    ...SalaryDecisionEN,
    ...RewardDecisionEN,
    ...AppointmentDecisionEN,
    ...AdmissionDecisionEN,
    ...ReasonEN,
    ...TransferDecisionEN,
    ...ContractDecisionEN
}